import './Stats.css'

const Stats = () => {
  return (
    <section className="stats">
      <div className="stats-container">
        <div className="stat-item">
          <span className="stat-number">37</span>
          <span className="stat-label">Ára reynsla</span>
        </div>

        <div className="stat-item">
          <span className="stat-number">200.000+</span>
          <span className="stat-label">Kaffibollar</span>
        </div>

        <div className="stat-item">
          <span className="stat-number">15</span>
          <span className="stat-label">Starfsmenn</span>
        </div>
      </div>
    </section>
  )
}

export default Stats
